document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.video-supports-new');

  const supportsHEVCAlpha = () => {
    const ua = navigator.userAgent.toLowerCase();
    const hasMediaCapabilities = !!(navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo);
    const isSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('version/') != -1;
    return isSafari && hasMediaCapabilities;
  };

  videoContainers.forEach((videoContainer) => {
    // Získání hodnot z data- atributů
    const src = videoContainer.getAttribute('data-src');
    const width = videoContainer.getAttribute('data-width');
    const height = videoContainer.getAttribute('data-height');

    const autoplay = videoContainer.getAttribute('data-autoplay') !== 'false';
    const muted = videoContainer.getAttribute('data-muted') !== 'false';
    const loop = videoContainer.getAttribute('data-loop') !== 'false';
    const playsInline = videoContainer.getAttribute('data-playsInline') !== 'false';

    // Vytvoření video elementu
    const videoElement = document.createElement('video');
    videoElement.className = 'video-element'; // Můžete přidat další třídy dle potřeby
    if (width) videoElement.width = width;
    if (height) videoElement.height = height;
    videoElement.autoplay = autoplay;
    videoElement.muted = muted;
    videoElement.loop = loop;
    videoElement.playsInline = playsInline;
    videoElement.preload = 'metadata';

    // Vytvoření source elementu
    const sourceElement = document.createElement('source');
    sourceElement.src = supportsHEVCAlpha() ? `${src}.mov` : `${src}.webm#t=0.05`;
    sourceElement.type = supportsHEVCAlpha() ? 'video/quicktime' : 'video/webm';

    // Připojení source k video elementu a video elementu do videoContaineru
    videoElement.appendChild(sourceElement);
    videoContainer.appendChild(videoElement);
  });
});
